import { t } from "@/context/language";
import { trackEvent } from "@/lib/dataLayer";
import { ArrowUpRight } from "lucide-react";
import { PRESS_ARTICLES } from "../constants/pressArticles";

export function PressHighlights() {

  // Casado pelo veículo, não pela posição: se as traduções e os assets saírem
  // de sincronia, a matéria some da seção em vez de virar um card com link e
  // logo vazios.
  const articles = t.press.items
    .map(item => {
      const asset = PRESS_ARTICLES[item.outlet];
      return asset ? { ...item, ...asset } : null;
    })
    .filter(article => article !== null);

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-3 text-center">
        <span className="text-primary text-sm font-semibold tracking-wide uppercase">
          {t.press.eyebrow}
        </span>
        <h2 className="text-3xl leading-tight font-bold text-black sm:text-4xl">
          {t.press.title}
        </h2>
        <p className="mx-auto max-w-2xl text-base text-gray-600 sm:text-lg">
          {t.press.subtitle}
        </p>
      </div>

      <ul className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {articles.map(article => (
          <li key={article.url} className="flex">
            <a
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackEvent({
                  event: "press_article_click",
                  outlet: article.outlet,
                })
              }
              className="focus-visible:outline-primary group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white transition hover:-translate-y-1 hover:border-gray-300 hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              <div className="flex h-24 items-center border-b border-gray-100 bg-gray-50 px-5">
                <img
                  src={article.logo}
                  alt={article.logoAlt}
                  width={article.logoWidth}
                  height={article.logoHeight}
                  loading="lazy"
                  className={`w-auto max-w-[70%] object-contain opacity-70 brightness-0 transition group-hover:opacity-100 ${article.logoClassName}`}
                />
              </div>

              <div className="flex flex-1 flex-col gap-3 p-5">
                <span className="text-xs font-medium text-gray-500">
                  {article.date}
                </span>

                <h3 className="text-lg leading-snug font-bold text-black">
                  {article.title}
                </h3>

                <p className="text-sm leading-relaxed text-gray-600">
                  {article.excerpt}
                </p>

                <span className="text-primary mt-auto inline-flex items-center gap-1 pt-2 text-sm font-semibold">
                  {t.press.readMore}
                  <ArrowUpRight
                    className="size-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    aria-hidden="true"
                  />
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
